//töötab comboboxiga aga ei loe tagasi väärtust
// töötav ilma formiku ja form ita
import React, { useState } from 'react'
import SearchContext from './SearchContext'
//import AlertDialog from './components/AlertDialog'
import { mongodb, client, useAuth } from './Auth/use-auth'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import CssBaseline from '@material-ui/core/CssBaseline'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Link from '@material-ui/core/Link'
import Grid from '@material-ui/core/Grid'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import moment from 'moment'
import { useParams } from 'react-router-dom'
import { FormLabel } from '@material-ui/core'
import { BlockPicker } from 'react-color'
const useStyles = makeStyles(theme => ({
  layout: {
    width: '100%',

    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    }
  },
  buttons: {
    width: '80%',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {
    width: 'auto',
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
    color: theme.palette.primary.dark
  },
  info: {
    color: theme.palette.primary.dark
  }
  // ,

  // textField: {
  //   textTransform: 'capitalize'
  // },
  // formControl: {
  //   display: 'grid',
  //   margin: theme.spacing(2),
  //   minWidth: '50%'
  // }
}))
const DarkerDisabledTextField = withStyles({
  root: {
    marginRight: 8,
    '& .MuiInputBase-root.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.6)' // (default alpha is 0.38)
    }
  }
})(TextField)
const ColorChange = withStyles({
  root: {
    marginRight: 8,
    '& .MuiInputBase-root.Mui-disabled': {
      colorBackground: '#8BC34A' // (default alpha is 0.38)
    }
  }
})(TextField)
export default function UpdateJob (props) {
  const classes = useStyles()
  const auth = useAuth()
  const { selectedDate, setSelectedDate } = React.useContext(SearchContext)
  //const { user } = React.useContext(MongoContext)
  const [jobInfo, setJobInfo] = useState([])
  const [activClient, setActivClient] = useState([])
  const [activCar, setActivCar] = useState([])
  // const [jobStatus, SetJobStatus] = useState(jobInfo.status)

  const { jobId } = useParams()

  const db = mongodb.db('silmandDB')
  setSelectedDate(jobInfo.start_time)
  //colorpicker
  const colors = [
    '#4caf50',
    '#8bc34a',
    '#cddc39',
    '#f44336',
    '#e91e63',
    '#9c27b0',
    '#673ab7',
    '#3f51b5',
    '#2196f3',
    '#03a9f4'
  ]
  const [backgroundcolor, setBackground] = useState(jobInfo.bgColor)
  React.useEffect(() => {
    if (auth) {
      readJobData(jobId)
      readClientData()
      setSelectedDate(jobInfo.start_time)
      setBackground(jobInfo.bgColor)
    }
  }, [])

  const readJobData = async jobId => {
    try {
      const dbJobs = db.collection('items')

      return await dbJobs
        .find({ _id: parseInt(jobId) })
        .asArray()
        .then(putToJobInfo)
    } catch (e) {
      console.log('item find viga', e)
    } finally {
    }
  }

  const putToJobInfo = async dbJobs => {
    await dbJobs.map(dbJob => {
      setJobInfo({
        group: dbJob.group,
        title: dbJob.carNumber
          ? `${dbJob.clientShortName}---${dbJob.carNumber}`
          : ' ',
        start_time: dbJob.start_time,
        end_time: dbJob.end_time,
        clientId: dbJob.clientId,
        clientShortName: dbJob.clientShortName,
        carNumber: dbJob.carNumber,
        carId: dbJob.carId,
        symptoms: dbJob.symptoms,
        solved: dbJob.solved,
        odo: dbJob.odo,
        status: dbJob.status,
        bgColor: dbJob.bgColor
      })
      setBackground(dbJob.bgColor)
    })
  }
  const readClientData = async () => {
    try {
      const dbClients = db.collection('clients')

      return await dbClients
        .find({}, { sort: { clientShortName: 1 } })

        .asArray()
        .then(aclients => {
          setActivClient(aclients)
        })
    } catch (e) {
      console.log('item find viga', e)
    } finally {
      console.log('kliendid', activClient)
    }
  }
  const readCarData = async clientId => {
    activClient.map(aClient => {
      if (aClient._id == clientId) {
        setJobInfo({
          ...jobInfo,
          clientShortName: aClient.clientShortName,
          clientId: aClient._id
        })
      }
    })

    try {
      const dbCars = db.collection('clientCars')

      return await dbCars
        .find({ clientId: parseInt(clientId) }, 'carNr')
        .asArray()
        .then(acars => {
          setActivCar(acars)
        })
    } catch (e) {
      console.log('item find viga', e)
    } finally {
    }
  }
  const changejobData = async () => {
    try {
      await db.collection('items').updateOne(
        { _id: parseInt(jobId) },
        {
          $set: {
            title: `${jobInfo.clientShortName}---${jobInfo.carNumber}`,
            clientId: jobInfo.clientId,
            clientShortName: jobInfo.clientShortName,
            carId: jobInfo.carId,
            carNumber: jobInfo.carNumber,
            symptoms: jobInfo.symptoms,
            solved: jobInfo.solved,
            odo: jobInfo.odo,
            status: jobInfo.status,
            bgColor: backgroundcolor
          }
        }
      )
    } catch (e) {
      console.log('item find viga', e)
    } finally {
      props.history.go(-1)
    }
  }
  const handleCancel = () => {
    props.history.go(-1)
  }
  const handleDelete = async event => {
    event.preventDefault()
    const answer = window.confirm('Kas Kustutada?')
    if (answer) {
      try {
        await db
          .collection('items')
          .deleteOne({
            _id: parseInt(jobId)
          })
          .then(handleCancel)
      } catch (e) {
        console.log('item kirjutamise viga', e)
      } finally {
      }
    }
  }
  const handleChangeJob = e => {
    setJobInfo({ ...jobInfo, [e.target.name]: e.target.value })
  }
  const handleChangeStatus = e => {
    //debugger
    // setJobInfo({ ...jobInfo, [e.target.name]: e.target.checked })
    e.target.checked == 0
      ? setJobInfo({ ...jobInfo, [e.target.name]: 0, bgColor: backgroundcolor })
      : setJobInfo({ ...jobInfo, [e.target.name]: 1, bgColor: backgroundcolor })
  }

  const handleChangeCar = e => {
    activCar.map(aCar => {
      if (aCar._id == e.target.value) {
        setJobInfo({ ...jobInfo, carNumber: aCar.carNr, carId: aCar._id })
      }
    })
  }
  const handleChangeColor = (color, event) => {
    return setBackground(color.hex)

    // color = {
    //   hex: '#333',
    //   rgb: {
    //     r: 51,
    //     g: 51,
    //     b: 51,
    //     a: 1,
    //   },
    //   hsl: {
    //     h: 0,
    //     s: 0,
    //     l: .20,
    //     a: 1,
    //   },
    // }
  }
  const handleBackgroundColor = (color, event) => {
    return setBackground(color.hex)
  }
  // moment(jobInfo.start_time, 'x').format('DD/MM/YY')
  return (
    <React.Fragment>
      <CssBaseline />
      <main className={classes.layout}>
        <Paper className={classes.paper}>
          <Grid container spacing={3}>
            <ColorChange
              disabled
              InputLabelProps={{ shrink: true }}
              id='kuup'
              name='kuup'
              label='Kuupäev'
              type='text'
              value={moment(jobInfo.start_time, 'x').format('DD/MM/YY')}
            />

            <Grid item xs={12} sm={12}>
              {jobInfo.carNumber ? (
                <TextField
                  disabled
                  fullWidth
                  id='clientShort'
                  value={jobInfo.clientShortName}
                  variant='filled'
                />
              ) : (
                <Select
                  fullWidth
                  variant='outlined'
                  value={jobInfo.clientId}
                  onClose={e => readCarData(e.target.id)}
                  inputProps={{
                    name: 'clientId',
                    id: 'client',
                    value: client._Id
                  }}
                >
                  {activClient.map(client => (
                    <MenuItem
                      id={client._id}
                      key={client._id}
                      value={client._id}
                    >
                      {client.clientShortName}
                    </MenuItem>
                  ))}
                </Select>
              )}
            </Grid>
            <Grid item xs={12} sm={12}>
              {jobInfo.carNumber ? (
                <Link
                  href={`#/viewCar/${jobInfo.carId}/${jobInfo.clientShortName}`}
                >
                  <TextField
                    fullWidth
                    id='carNumber'
                    value={jobInfo.carNumber}
                    variant='filled'
                  />
                </Link>
              ) : (
                <Select
                  fullWidth
                  variant='outlined'
                  value={jobInfo.carId}
                  onChange={handleChangeCar}
                  inputProps={{
                    name: 'carId',
                    id: 'cars'
                  }}
                >
                  {activCar.map(car => (
                    <MenuItem id={car._id} value={car._id}>
                      {car.carNr}
                    </MenuItem>
                  ))}
                </Select>
              )}
            </Grid>
            <br />
            <Grid item xs={12} sm={12}>
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                variant='outlined'
                id='odo'
                name='odo'
                label='Labisoit'
                type='text'
                onChange={handleChangeJob}
                value={jobInfo.odo}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                variant='outlined'
                id='symptoms'
                name='symptoms'
                label='Vea kirjeldus kliendilt'
                type='text'
                onChange={handleChangeJob}
                value={jobInfo.symptoms}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              {activCar.map(car =>
                car._id == jobInfo.carId ? (
                  <DarkerDisabledTextField
                    disabled
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    variant='outlined'
                    id='carH'
                    name='carH'
                    label='Ajalugu'
                    multiline
                    rowsMax={6}
                    value={car.carHistory}
                  />
                ) : (
                  ''
                )
              )}
            </Grid>
            <div>
              <BlockPicker
                colors={colors}
                color={backgroundcolor}
                width='170%'
                triangle='hide'
                onChangeComplete={handleChangeColor}
              />
            </div>
            <Grid item xs={12} sm={12}>
              {jobInfo.status ? (
                <FormLabel>
                  <Checkbox
                    variant='outlined'
                    color='secondary'
                    name='status'
                    checked={jobInfo.status}
                    value={jobInfo.status}
                    onChange={handleChangeStatus}
                    label={'Lõpetatud'}
                  />
                  Lõpetatud
                </FormLabel>
              ) : (
                <FormControlLabel
                  control={
                    <Checkbox
                      variant='outlined'
                      color='secondary'
                      name='status'
                      checked={jobInfo.status}
                      value={jobInfo.status}
                      onChange={handleChangeStatus}
                    />
                  }
                  label='Lõpetatud'
                />
              )}
            </Grid>

            <div className={classes.buttons}>
              <Button
                type='submit'
                onClick={changejobData}
                className={classes.button}
              >
                Muuda
              </Button>
              <Button onClick={handleDelete} className={classes.button}>
                Kustuta
              </Button>

              <Button onClick={handleCancel} className={classes.button}>
                Tagasi
              </Button>
            </div>
          </Grid>
        </Paper>
      </main>
    </React.Fragment>
  )
}
// <TextField
//   InputLabelProps={{ shrink: true }}
//   fullWidth
//   variant='outlined'
//   id='solved'
//   name='solved'
//   label='Tööde kirjeldus'
//   type='text'
//   onChange={handleChangeJob}
//   value={jobInfo.solved}
// />
// <Grid item xs={12} sm={12}>
//   <TextField
//     InputLabelProps={{ shrink: true }}
//     disabled='true'
//     fullWidth
//     variant='outlined'
//     id='title'
//     name='title'
//     label='Kirjeldus'
//     type='text'
//     onChange={handleChangeJob}
//     value={jobInfo.title}
//   />
// </Grid>
